import { OverlayRef } from '@angular/cdk/overlay';
import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'ds-custom-tooltip',
  templateUrl: './custom-tooltip.component.html',
  styleUrls: ['./custom-tooltip.component.css'],
})
export class CustomTooltipComponent {
  @Input() text: string;

  @Input() contentTemplate: TemplateRef<any>;

  @Input() _overlayRef: OverlayRef = null;

  constructor() {}

  mouseLeave() {
    if(this._overlayRef)
      this._overlayRef.detach();
  }
}
